export default {
    frames: {
        title: 'Frames',
        customFrame: 'Custom frame',
        pastel: 'Pastel',
        decorative: 'Decorative',
        wooden: 'Wooden',
        gradient: 'Gradient',
        solid: 'Solid',
        movie: 'Movie',
        removeFrame: 'Remove frame',
        customImage: 'Custom Image',
        frameOpacity: 'Frame Opacity',
    },
};
